var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"flex-1 flex justify-center items-center outline-none opacity-50",attrs:{"to":_vm.to}},[_c('v-icon',{attrs:{"name":_vm.icon,"scale":"1.45"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }